import ApplicationController from './application_controller'

class QualificationDateValidationController extends ApplicationController {
  connect () {
    this.form = this.element
    // Use capture phase to run before Rails UJS disables the button
    this.form.addEventListener('submit', this.validateDates.bind(this), true)

    // Clear custom validity on date change
    this.form.querySelectorAll('.datepicker').forEach(input => {
      input.addEventListener('change', () => this.clearValidation())
    })
  }

  disconnect () {
    this.form.removeEventListener('submit', this.validateDates.bind(this))
  }

  validateDates (event) {
    const startDateInput = this.form.querySelector('input[id*="startdate"]')
    const endDateInput = this.form.querySelector('input[id*="enddate"]')

    if (!startDateInput || !endDateInput) return true

    const startDateValue = startDateInput.value.trim()
    const endDateValue = endDateInput.value.trim()

    // Clear previous validation
    this.clearValidation()

    // If end date is not set, it's valid
    if (!endDateValue) {
      return true
    }

    // If start date is not set but end date is set, it's valid
    if (!startDateValue) {
      return true
    }

    // Parse dates in dd.mm.yyyy format
    const startDate = this.parseDate(startDateValue)
    const endDate = this.parseDate(endDateValue)

    if (!startDate || !endDate) {
      return true
    }

    if (startDate > endDate) {
      event.preventDefault()
      event.stopImmediatePropagation()

      const errorMessage = I18n.t('errors.messages.start_date_after_end_date')

      // Use native HTML5 validation API to show browser popup
      endDateInput.setCustomValidity(errorMessage)
      endDateInput.reportValidity()

      // Re-enable submit button if it was disabled by Rails UJS
      this.resetSubmitButton()

      return false
    }

    return true
  }

  parseDate (dateString) {
    // Parse dd.mm.yyyy format
    const parts = dateString.split('.')
    if (parts.length !== 3) return null

    const day = parseInt(parts[0], 10)
    const month = parseInt(parts[1], 10)
    const year = parseInt(parts[2], 10)

    if (isNaN(day) || isNaN(month) || isNaN(year)) return null

    return new Date(year, month - 1, day)
  }

  clearValidation () {
    this.form.querySelectorAll('.datepicker').forEach(input => {
      input.setCustomValidity('')
    })
  }

  resetSubmitButton () {
    const submitButton = this.form.querySelector('input[type="submit"], button[type="submit"]')
    if (submitButton) {
      submitButton.disabled = false
      const originalText = submitButton.dataset.enableWith || submitButton.dataset.originalText
      if (originalText) {
        submitButton.value = originalText
        submitButton.textContent = originalText
      } else {
        const saveText = I18n.t('save')
        if (submitButton.tagName === 'INPUT') {
          submitButton.value = saveText
        } else {
          submitButton.textContent = saveText
        }
      }
    }
  }
}

export default QualificationDateValidationController
